/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import Vue from 'vue';

let instance;

/** Returns the current instance */
export const getInstance = () => instance;

/** Creates an instance of the Auth. If one has already been created, it returns that instance */
export const AuthInst = ({
    ...options
}) => {
    if (instance) return instance;

    // The 'instance' is simply a Vue object
    instance = new Vue({
        data() {
            return {
                loading: false,
                isAuthenticated: false,
                loginPopup: false,
                loginError: false,
                customerSelectPopup: false,
                customerSelectError: false,
                customerId: null,
                accountId: null,
                subscription: null,
                functionGroups: [],
                hasOneCustomer: false,
                isAdmin: false,
            };
        },
        methods: {
            async showLogin() {
                this.loginPopup = true;
            },
            /* called when page is opened to check if we are already logged in */
            async check() {
                console.log("Check login");
                var res = await this.$axios.get(route('api.auth.check'))
                // here we could set the accountId, companyIds, isAdmin if needed
                this.accountId = res.data.accountId
                this.hasOneCustomer = res.data.companyIds.length === 1;
                this.isAdmin = res.data.isAdmin;
                console.log("User is logged in");
                this.isAuthenticated = true;
                this.checkCustomer();
            },
            /* check if the user has one customer or he needs to select one */
            checkCustomer() {
                // always ask the server for the customer, if there is only one it is automatically selected but we need the subcription name
                this.$axios.get(route('api.auth.getcustomer'))
                    .then(res => {
                        if (res.data.customerId) {
                            this.customerId = res.data.customerId;
                            this.subscription = res.data.subscription;
                            this.functionGroups = res.data.functiongroups;
                        } else {
                            this.customerSelectPopup = true;
                        }
                    })
                    .catch(err => {
                        console.log("CheckCustomer error");
                        console.log(err);
                        console.error("Could not check if user has customer selected");
                        this.customerSelectPopup = true;
                    });
            },
            switchCustomer() {
                this.customerSelectPopup = true;
            },
            setCustomer(customerId) {
                this.$cancelSource.cancel('TEST CANCEL FROM AUTH INTERCEPT IMPLEMENTATION');
                this.$axios.post(route('api.auth.setcustomer', customerId))
                    .then(res => {
                        if (this.customerId) {
                            window.location.reload();
                            return;
                        }
                        this.customerId = customerId;
                        this.subscription = res.data.subscription;
                        this.functionGroups = res.data.functiongroups;

                        this.customerSelectPopup = false;
                    })
                    .catch(err => {
                        console.error("Could not set selected customer");
                        if (err.response) {
                            this.customerSelectError = err.response.data;
                        } else {
                            this.customerSelectError = true;
                        }
                    });
            },
            login(email = ' ', password = ' ') {
                this.loginError = null;
                console.log("Do login");
                this.$axios.post(route('api.auth.login'), { email: email, password: password })
                    .then(() => {
                        console.log("User is logged in");
                        this.isAuthenticated = true;
                        this.loginPopup = false;
                        this.check();
                    })
                    .catch(err => {
                        console.log(err.response.data);
                        this.loginError = err.response.data.reason;
                    });
            },
            logout() {
                this.loginError = null;
                console.log("Do logout");
                console.log(this.$cancelSource)
                this.$cancelSource.cancel('TEST CANCEL FROM AUTH INTERCEPT IMPLEMENTATION');
                this.$axios.post(route('api.auth.logout'))
                    .then(() => {
                        window.location.reload();
                    });
            },
        },
        /** Created lifecycle method */
        async created() {

        },
    });

    return instance;
};

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const Auth = {
    install(Vue, options) {
        Vue.prototype.$auth = AuthInst(options);
    },
};